import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../utils/api";

function ChangePassword({ setBanner }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const navigate = useNavigate();

  const showBanner = (payload) => {
    if (typeof setBanner === "function") {
      setBanner(payload);
    } else {
      alert(payload.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      showBanner({
        type: "danger",
        message: "Password must be at least 8 characters long.",
      });
      return;
    }
    if (password !== confirm) {
      showBanner({ type: "danger", message: "Passwords do not match." });
      return;
    }

    try {
      const res = await changePassword(password);
      if (res.success) {
        showBanner({
          type: "success",
          message: "Password changed successfully!",
        });
        navigate("/admin");
      } else {
        showBanner({
          type: "danger",
          message: res.message || "Error changing password.",
        });
      }
    } catch (err) {
      console.error(err);
      showBanner({
        type: "danger",
        message: "Server error occurred while changing password.",
      });
    }
  };

  return (
    <div className="container mt-5 pt-4">
      <h2>🔒 Change Password</h2>
      <form
        onSubmit={handleSubmit}
        className="mx-auto"
        style={{ maxWidth: "400px" }}
      >
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter new password"
          />
          <small className="text-muted">Must be at least 8 characters.</small>
        </div>
        <div className="mb-3">
          <label className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            placeholder="Re-enter new password"
          />
        </div>
        <button type="submit" className="btn btn-success w-100">
          Update Password
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
